import React from 'react';

import TextField from '@material-ui/core/TextField/TextField';

import { useStyles } from './Themable.hooks';
import PaneHeader from '../../../../../../components/PaneHeader/PaneHeader';
import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import { resetMode } from '../../../../state';
import { Tooltip } from '@material-ui/core';
import IconButtonWithTooltip from '../../../../../../components/IconButtonWithTooltip';
import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';
import { useAppDispatch, useToolkitDispatch } from '../../../../../../hooks';
import { useSelectedProduct } from '../../../../state/index.hooks';
import { showProductAssignmentDialog } from '../../../../../../state/ui/dialog';
import { DELAY } from '../../../../../../constants/TooltipSettings';

const ProductPreview = () => {
    const classes = useStyles();
    const selectedProduct = useSelectedProduct();

    const toolkitDispatch = useToolkitDispatch();
    const dispatch = useAppDispatch();

    const handleClose = () => {
        toolkitDispatch(resetMode());
    };

    const getRightCustomControls = () => (
        <>
            <IconButtonWithTooltip
                title={TranslationHelper.translate('Assigning to product')}
                onClick={handleOpenDialog}
            >
                <CategoryOutlinedIcon />
            </IconButtonWithTooltip>
        </>
    );

    const handleOpenDialog = () => {
        if (selectedProduct) {
            dispatch(showProductAssignmentDialog({ selectedProduct }));
        }
    };

    return (
        <div>
            <PaneHeader
                onCloseClick={handleClose}
                title={TranslationHelper.translate('Product details')}
                renderRightCustomControls={() => getRightCustomControls()}
            />

            <div className={classes.formWrapper}>
                <Tooltip
                    title={selectedProduct?.name || ''}
                    placement="top"
                    enterDelay={DELAY}
                    leaveDelay={DELAY}
                    enterNextDelay={DELAY}
                >
                    <TextField
                        label={TranslationHelper.translate('Name')}
                        value={selectedProduct?.name || ''}
                        disabled={true}
                        fullWidth={true}
                        inputProps={{ className: classes.inputWrapper }}
                    />
                </Tooltip>
                <Tooltip
                    title={selectedProduct?.description || ''}
                    placement="top"
                    enterDelay={DELAY}
                    leaveDelay={DELAY}
                    enterNextDelay={DELAY}
                >
                    <TextField
                        label={TranslationHelper.translate('Description')}
                        value={selectedProduct?.description || ''}
                        inputProps={{ className: classes.inputWrapper }}
                        disabled={true}
                        fullWidth={true}
                    />
                </Tooltip>
            </div>
        </div>
    );
};

export default ProductPreview;
